import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NoContentStubComponent } from '@frontendlib/components/components/no-content-stub/no-content-stub.component';
import { type KPListType } from '@modules/knowledge/types/kp-list-type';
import { getKPResultType, type KPResultType } from '@modules/knowledge/types/kp-result-types';

export type KPResultsEmptyState = 'blank' | 'idle' | 'none';

/** What the knowledge panel's results list shows in place of results. */
@Component({
  selector: 'app-kp-results-empty',
  templateUrl: './kp-results-empty.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NoContentStubComponent],
  host: {
    class: 'contents',
  },
})
export class KPResultsEmptyComponent {
  public readonly state = input.required<KPResultsEmptyState>();
  public readonly type = input.required<KPListType>();

  private readonly resultType = computed<KPResultType | undefined>(() => getKPResultType(this.type()));
  protected readonly noun = computed<string>(() => this.resultType()?.noun ?? '');
  protected readonly image = computed<string>(() => this.resultType()?.image ?? '');
}
